import clsx from "clsx";
import type { CellContext, ColumnMeta } from "@tanstack/react-table";
import { type BusinessSubscription } from "lens-platform-sdk";

import { getPlanName } from "src/services/plans";
import { trimUUID } from "src/services/trimUUID";

import styles from "./SubscriptionCell.module.css";

const SubscriptionCell = <T extends {}, R extends BusinessSubscription | null | undefined>({
  getValue,
  className,
}: CellContext<T, R> & { className?: string }) => {
  const subscription = getValue();

  if (!subscription) {
    return null;
  }
  const { planCode, id } = subscription;

  return (
    <div className={clsx(styles.subscription, className)}>
      <div className={styles.subscriptionPlanName}>{getPlanName(planCode)}</div>
      <div className={styles.subscriptionId} title={id}>
        {trimUUID(id)}
      </div>
    </div>
  );
};

export const subscriptionCellMeta: ColumnMeta<unknown, unknown> | undefined = {};

export const subscriptionColDef = {
  meta: subscriptionCellMeta,
  header: () => <span>Subscription</span>,
  cell: SubscriptionCell,
};

export default SubscriptionCell;
